import { action, createRequestTypes } from './base';

export const moActionTypes = {
  GET_MO: createRequestTypes('GET_MO'),
  GET_MO_BY_ID: createRequestTypes('GET_MO_BY_ID'),
  CREATE_MO: createRequestTypes('CREATE_MO'),
  CREATE_MO_ADJUSTMENT: createRequestTypes('CREATE_MO_ADJUSTMENT'),
  UPDATE_MO: createRequestTypes('UPDATE_MO'),
  UPDATE_STATUS_MO: createRequestTypes('UPDATE_STATUS_MO'),
  DELETE_MO: createRequestTypes('DELETE_MO'),
  ARCHIVE_MO: createRequestTypes('ARCHIVE_MO'),
  UPDATE_MO_ADJUSTMENT_STATUS: createRequestTypes('UPDATE_MO_ADJUSTMENT_STATUS'),
  UPDATE_MO_OTHER_CHARGES: createRequestTypes('UPDATE_MO_OTHER_CHARGES'),
  GET_MO_JOB_WORKS: createRequestTypes('GET_MO_JOB_WORKS'),
  GET_DOWNLOAD_MO: createRequestTypes('GET_DOWNLOAD_MO'),
  ADD_RM: createRequestTypes('ADD_RM'),
  REMOVE_RM: createRequestTypes('REMOVE_RM'),
  SWAP_RM: createRequestTypes('SWAP_RM'),
  GET_WORK_ORDER_RM: createRequestTypes('GET_WORK_ORDER_RM'),
  GET_MASTER_PRODUCTION_PROCESS: createRequestTypes('GET_MASTER_PRODUCTION_PROCESS'),
  UPDATE_MASTER_PRODUCTION_PROCESS: createRequestTypes('UPDATE_MASTER_PRODUCTION_PROCESS'),
  GET_MASTER_PRODUCTION_SCHEDULE: createRequestTypes('GET_MASTER_PRODUCTION_SCHEDULE'),
  GET_MACHINE_SCHEDULE: createRequestTypes('GET_MACHINE_SCHEDULE'),
  SCHEDULE_MACHINE: createRequestTypes('SCHEDULE_MACHINE'),
  RECALCULATE_PRODUCTION_SCHEDULE: createRequestTypes('RECALCULATE_PRODUCTION_SCHEDULE'),
  DELETE_MACHINE_SCHEDULE: createRequestTypes('DELETE_MACHINE_SCHEDULE'),
  GENERATE_SLIP: createRequestTypes('GENERATE_SLIP'),
  BULK_GENERATE_SLIP: createRequestTypes('BULK_GENERATE_SLIP'),
};

class MOActions {
  getMO = (tenantId, moId, status, page, limit, searchKeyword, callback, sellerId, departmentId, fromDate, toDate, listScreen, isArchived, isWeightedAverage, scheduledStartDate, scheduledEndDate, isLinkedMrp, source, customerId, salesOrderNumber, isScheduled) => action(moActionTypes.GET_MO.REQUEST, {
    tenantId, moId, status, page, limit, searchKeyword, callback, sellerId, departmentId, fromDate, toDate, listScreen, isArchived, isWeightedAverage, scheduledStartDate, scheduledEndDate, isLinkedMrp, source, customerId, salesOrderNumber, isScheduled
  })

  getMOLoading = (getMOLoading) => action(moActionTypes.GET_MO.LOADING, {
    getMOLoading,
  })

  getMOSuccess = (manufacturingOrders) => action(moActionTypes.GET_MO.SUCCESS, {
    manufacturingOrders,
  })

  getMOById = (tenantId, moId, costingMethod) => action(moActionTypes.GET_MO_BY_ID.REQUEST, {
    tenantId, moId, costingMethod,
  })

  getMOByIdLoading = (getMOByIdLoading) => action(moActionTypes.GET_MO_BY_ID.LOADING, {
    getMOByIdLoading,
  })

  getMOByIdSuccess = (selectedMO) => action(moActionTypes.GET_MO_BY_ID.SUCCESS, {
    selectedMO,
  })

  createMO = (payload, callback) => action(moActionTypes.CREATE_MO.REQUEST, {
    payload,
    callback,
  })

  createMOLoading = (createMOLoading) => action(moActionTypes.CREATE_MO.LOADING, {
    createMOLoading,
  })

  updateMO = (payload, callback) => action(moActionTypes.UPDATE_MO.REQUEST, {
    payload,
    callback,
  })

  updateMOLoading = (updateMOLoading) => action(moActionTypes.UPDATE_MO.LOADING, {
    updateMOLoading,
  })

  updateMOOtherCharges = (payload, callback) => action(moActionTypes.UPDATE_MO_OTHER_CHARGES.REQUEST, {
    payload,
    callback,
  })

  updateMOOtherChargesLoading = (updateMOOtherChargesLoading) => action(moActionTypes.UPDATE_MO_OTHER_CHARGES.LOADING, {
    updateMOOtherChargesLoading,
  })

  updateMOStatus = (payload, callback) => action(moActionTypes.UPDATE_STATUS_MO.REQUEST, {
    payload, callback,
  })

  updateMOStatusLoading = (updateMOStatusLoading) => action(moActionTypes.UPDATE_STATUS_MO.LOADING, {
    updateMOStatusLoading,
  })

  deleteMO = (payload, callback) => action(moActionTypes.DELETE_MO.REQUEST, {
    payload, callback,
  })

  deleteMOLoading = (deleteMOLoading) => action(moActionTypes.DELETE_MO.LOADING, {
    deleteMOLoading,
  })

  archiveMo = (payload, callback) => action(moActionTypes.ARCHIVE_MO.REQUEST, {
    payload, callback,
  })

  archiveMoLoading = (archiveMoLoading) => action(moActionTypes.ARCHIVE_MO.LOADING, {
    archiveMoLoading,
  })

  createMOAdjustment = (payload, callback) => action(moActionTypes.CREATE_MO_ADJUSTMENT.REQUEST, {
    payload,
    callback,
  })

  createMOAdjustmentLoading = (createMOAdjustmentLoading) => action(moActionTypes.CREATE_MO_ADJUSTMENT.LOADING, {
    createMOAdjustmentLoading,
  })

  updateMOAdjustmentStatus = (payload, callback) => action(moActionTypes.UPDATE_MO_ADJUSTMENT_STATUS.REQUEST, {
    payload,
    callback,
  })

  updateMOAdjustmentStatusLoading = (updateMOAdjustmentStatusLoading) => action(moActionTypes.UPDATE_MO_ADJUSTMENT_STATUS.LOADING, {
    updateMOAdjustmentStatusLoading,
  })

  getMoJobWorks = (payload, callback) => action(moActionTypes.GET_MO_JOB_WORKS.REQUEST, {
    payload, callback,
  })

  getMoJobWorksLoading = (getMoJobWorksLoading) => action(moActionTypes.GET_MO_JOB_WORKS.LOADING, {
    getMoJobWorksLoading,
  })

  getMoJobWorksSuccess = (moJobWorks) => action(moActionTypes.GET_MO_JOB_WORKS.SUCCESS, {
    moJobWorks,
  })

  getDownloadMO = (payload, callback) => action(
    moActionTypes.GET_DOWNLOAD_MO.REQUEST, {
      payload, callback,
    },
  )

  getDownloadMOLoading = (getDownloadMOLoading) => action(moActionTypes.GET_DOWNLOAD_MO.LOADING, {
    getDownloadMOLoading,
  })

  addRM = (payload, callback) => action(moActionTypes.ADD_RM.REQUEST, { payload, callback })

  addRMLoading = (addRMLoading) => action(moActionTypes.ADD_RM.LOADING, { addRMLoading })

  removeRM = (payload, callback) => action(moActionTypes.REMOVE_RM.REQUEST, { payload, callback })

  removeRMLoading = (removeRMLoading) => action(moActionTypes.REMOVE_RM.LOADING, { removeRMLoading })

  swapRM = (payload, callback) => action(moActionTypes.SWAP_RM.REQUEST, { payload, callback })

  swapRMLoading = (swapRMLoading) => action(moActionTypes.SWAP_RM.LOADING, { swapRMLoading })

  getWorkOrderRm = (payload, callback) => action(moActionTypes.GET_WORK_ORDER_RM.REQUEST, { payload, callback })

  getWorkOrderRmLoading = (getWorkOrderRmLoading) => action(moActionTypes.GET_WORK_ORDER_RM.LOADING, { getWorkOrderRmLoading })

  getWorkOrderRmSuccess = (workOrderRm) => action(moActionTypes.GET_WORK_ORDER_RM.SUCCESS, {
    workOrderRm,
  })

  getMasterProductionProcess = (payload, callback) => action(moActionTypes.GET_MASTER_PRODUCTION_PROCESS.REQUEST, { payload, callback });

  getMasterProductionProcessLoading = (getMasterProductionProcessLoading) => action(moActionTypes.GET_MASTER_PRODUCTION_PROCESS.LOADING, { getMasterProductionProcessLoading });

  getMasterProductionProcessSuccess = (masterProductionProcess) => action(moActionTypes.GET_MASTER_PRODUCTION_PROCESS.SUCCESS, {
    masterProductionProcess,
  });

  updateMasterProductionProcess = (payload, callback) => action(moActionTypes.UPDATE_MASTER_PRODUCTION_PROCESS.REQUEST, { payload, callback });

  updateMasterProductionProcessLoading = (updateMasterProductionProcessLoading) => action(moActionTypes.UPDATE_MASTER_PRODUCTION_PROCESS.LOADING, { updateMasterProductionProcessLoading });

  updateMasterProductionProcessSuccess = (updateMasterProductionProcessSuccess) => action(moActionTypes.UPDATE_MASTER_PRODUCTION_PROCESS.SUCCESS, { updateMasterProductionProcessSuccess });

  getMasterProductionSchedule = (payload, callback) => action(moActionTypes.GET_MASTER_PRODUCTION_SCHEDULE.REQUEST, { payload, callback });

  getMasterProductionScheduleLoading = (getMasterProductionScheduleLoading) => action(moActionTypes.GET_MASTER_PRODUCTION_SCHEDULE.LOADING, { getMasterProductionScheduleLoading });

  getMasterProductionScheduleSuccess = (masterProductionSchedule) => action(moActionTypes.GET_MASTER_PRODUCTION_SCHEDULE.SUCCESS, { masterProductionSchedule });

  getMachineSchedule = (payload, callback) => action(moActionTypes.GET_MACHINE_SCHEDULE.REQUEST, { payload, callback });

  getMachineScheduleLoading = (getMachineScheduleLoading) => action(moActionTypes.GET_MACHINE_SCHEDULE.LOADING, { getMachineScheduleLoading });

  getMachineScheduleSuccess = (machineSchedule) => action(moActionTypes.GET_MACHINE_SCHEDULE.SUCCESS, { machineSchedule });

  scheduleMachine = (payload, callback) => action(moActionTypes.SCHEDULE_MACHINE.REQUEST, { payload, callback });

  scheduleMachineLoading = (scheduleMachineLoading) => action(moActionTypes.SCHEDULE_MACHINE.LOADING, { scheduleMachineLoading });

  scheduleMachineSuccess = (scheduleMachineSuccess) => action(moActionTypes.SCHEDULE_MACHINE.SUCCESS, { scheduleMachineSuccess });

  recalculateProductionSchedule = (payload, callback) => action(moActionTypes.RECALCULATE_PRODUCTION_SCHEDULE.REQUEST, { payload, callback });

  recalculateProductionScheduleLoading = (recalculateProductionScheduleLoading) => action(moActionTypes.RECALCULATE_PRODUCTION_SCHEDULE.LOADING, { recalculateProductionScheduleLoading });

  recalculateProductionScheduleSuccess = (recalculateProductionScheduleSuccess) => action(moActionTypes.RECALCULATE_PRODUCTION_SCHEDULE.SUCCESS, { recalculateProductionScheduleSuccess });

  deleteMachineSchedule = (payload, callback) => action(moActionTypes.DELETE_MACHINE_SCHEDULE.REQUEST, { payload, callback });

  deleteMachineScheduleLoading = (deleteMachineScheduleLoading) => action(moActionTypes.DELETE_MACHINE_SCHEDULE.LOADING, { deleteMachineScheduleLoading });

  deleteMachineScheduleSuccess = (deleteMachineScheduleSuccess) => action(moActionTypes.DELETE_MACHINE_SCHEDULE.SUCCESS, { deleteMachineScheduleSuccess });

  generateSlip = (payload, callback) => action(moActionTypes.GENERATE_SLIP.REQUEST, { payload, callback });

  generateSlipLoading = (generateSlipLoading) => action(moActionTypes.GENERATE_SLIP.LOADING, { generateSlipLoading });

  generateSlipSuccess = (generateSlipSuccess) => action(moActionTypes.GENERATE_SLIP.SUCCESS, { generateSlipSuccess });

  bulkGenerateSlip = (payload, callback) => action(moActionTypes.BULK_GENERATE_SLIP.REQUEST, { payload, callback });

  bulkGenerateSlipLoading = (bulkGenerateSlipLoading) => action(moActionTypes.BULK_GENERATE_SLIP.LOADING, { bulkGenerateSlipLoading });

  bulkGenerateSlipSuccess = (bulkGenerateSlipSuccess) => action(moActionTypes.BULK_GENERATE_SLIP.SUCCESS, { bulkGenerateSlipSuccess });
}
export default new MOActions();
